<div class="login-shell">

  <!-- Left panel: branding -->
  <aside class="login-brand animate-fade-in">
    <div class="brand-content">
      <div class="brand-logo">
        <span class="material-symbols-outlined">architecture</span>
      </div>
      <h1 class="brand-title">Fluid Architect</h1>
      <p class="brand-subtitle">Scheduler profesional de turnos.<br>Elegante. Rápido. Sin fricción.</p>

      <div class="brand-features">
        <div class="feature-item">
          <span class="material-symbols-outlined" style="color:var(--primary)">calendar_check</span>
          <span>Reservas en tiempo real</span>
        </div>
        <div class="feature-item">
          <span class="material-symbols-outlined" style="color:var(--tertiary)">event_available</span>
          <span>Sync automático al calendario</span>
        </div>
        <div class="feature-item">
          <span class="material-symbols-outlined" style="color:var(--primary)">notifications_active</span>
          <span>Vista de profesional en vivo</span>
        </div>
      </div>
    </div>

    <div class="brand-deco" aria-hidden="true">
      <span class="material-symbols-outlined deco-icon">schedule</span>
    </div>
  </aside>

  <!-- Right panel: form -->
  <main class="login-form-panel animate-fade-in delay-2">
    <div class="login-card">

      <div class="login-header">
        <h2>Iniciar sesión</h2>
        <p>Elegí una cuenta demo para explorar la app</p>
      </div>

      <!-- Quick demo selector -->
      <div class="demo-accounts">
        <p class="form-label">Cuentas demo</p>
        <button
          *ngFor="let acc of demoAccounts"
          class="demo-btn"
          [class.demo-btn--selected]="form.get('email')?.value === acc.email"
          (click)="selectDemo(acc.email)"
        >
          <span class="demo-icon">
            <span class="material-symbols-outlined" style="font-size:1rem">
              {{ acc.role === 'professional' ? 'medical_services' : 'person' }}
            </span>
          </span>
          <span class="demo-label">{{ acc.label }}</span>
          <span class="demo-role-pill" [class.demo-role-pill--pro]="acc.role === 'professional'">
            {{ acc.role === 'professional' ? 'Profesional' : 'Cliente' }}
          </span>
        </button>
      </div>

      <form class="login-fields" [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group">
          <label class="form-label">Usuario</label>
          <input
            class="input-field"
            [class.input-field--error]="emailCtrl.invalid && emailCtrl.touched"
            type="text"
            placeholder="correo@ejemplo.com o admin"
            formControlName="email"
            autocomplete="username"
          />
          <span class="field-error" *ngIf="emailCtrl.invalid && emailCtrl.touched">
            El usuario es requerido.
          </span>
        </div>

        <div class="form-group">
          <label class="form-label">Contraseña <span class="hint">(cualquier valor en modo demo)</span></label>
          <input
            class="input-field"
            [class.input-field--error]="passwordCtrl.invalid && passwordCtrl.touched"
            type="password"
            placeholder="••••••••"
            formControlName="password"
          />
          <span class="field-error" *ngIf="passwordCtrl.invalid && passwordCtrl.touched">
            La contraseña es requerida.
          </span>
        </div>

        <div class="login-error" *ngIf="error">
          <span class="material-symbols-outlined">error</span>
          {{ error }}
        </div>

        <button class="btn-primary login-submit" type="submit" [disabled]="loading">
          <span *ngIf="!loading" class="material-symbols-outlined">login</span>
          <span *ngIf="loading" class="spinner"></span>
          {{ loading ? 'Ingresando...' : 'Ingresar' }}
        </button>
      </form>

      <p class="login-footer-note">
        <span class="material-symbols-outlined" style="font-size:.9rem">info</span>
        Modo mock — no se envían datos a ningún servidor.
      </p>
    </div>
  </main>

</div>
